import axios from "axios";
import { IPostBuyNow } from "../../interfaces/PurchaseNow";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;
const API_KEY = process.env.REACT_APP_API_KEY_PURCHASE_NOW;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: { "Api-Key": API_KEY },
});

export const postBuyNow = async (data: IPostBuyNow) => {
  const response = await api.post(`/web/campaign/buy`, data);
  return response;
};
